// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Delivery40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Delivery40: FC<Delivery40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M9.559 33.32c-1.373 0-2.54-.481-3.504-1.443-.962-.961-1.444-2.128-1.444-3.502H1.667V9.46c0-.75.275-1.401.826-1.952.551-.55 1.202-.826 1.952-.826h23.86v6.86h4.584l5.444 7.25v7.584H35.25c0 1.374-.48 2.54-1.441 3.502-.961.962-2.128 1.442-3.5 1.442-1.373 0-2.54-.48-3.504-1.442-.962-.961-1.444-2.128-1.444-3.502H14.5c0 1.37-.48 2.537-1.441 3.5-.961.963-2.128 1.444-3.5 1.444Zm-.004-2.778a2.09 2.09 0 0 0 1.535-.632 2.09 2.09 0 0 0 .632-1.535 2.09 2.09 0 0 0-.632-1.535 2.09 2.09 0 0 0-1.535-.631 2.09 2.09 0 0 0-1.534.631 2.09 2.09 0 0 0-.632 1.535c0 .602.21 1.113.632 1.535a2.09 2.09 0 0 0 1.534.632Zm-5.11-4.945H5.5A5.487 5.487 0 0 1 7.237 24a4.481 4.481 0 0 1 2.292-.597c.842 0 1.61.204 2.304.611a5.73 5.73 0 0 1 1.75 1.583h11.945V9.46H4.445v16.138Zm25.86 4.945a2.09 2.09 0 0 0 1.535-.632 2.09 2.09 0 0 0 .632-1.535 2.09 2.09 0 0 0-.632-1.535 2.09 2.09 0 0 0-1.535-.631 2.09 2.09 0 0 0-1.534.631 2.09 2.09 0 0 0-.632 1.535c0 .602.21 1.113.632 1.535a2.09 2.09 0 0 0 1.534.632Zm-2-8.445h7.528L31.5 16.32h-3.195v5.778Z" />
        </svg>
    );
};

export default Delivery40;
